import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import API from "../../api"
import HeaderComponent from "../../components/header/header.component"
import FooterComponent from "../../components/footer/footer.component"

const ClientDemoPage = () => {
  const { Slug } = useParams()
  const [content, setContent] = useState()
  const [password, setPassword] = useState("")
  const [error, setError] = useState()

  useEffect(() => {
    // Scroll top
    window.scrollTo(0, 0)
  }, [])

  const handleFetchPage = async () => {
    setError(false)

    try {
      const res = await API.getContent(
        "client-demo-pages",
        null,
        {
          "filters[$and][0][Slug][$eq]": Slug,
          "filters[$and][1][Password][$eq]": password,
          "populate[0]": "PageContent",
          "populate[1]": "PageContent.Media",
          "populate[2]": "PageContent.Items",
          "populate[3]": "PageContent.Items.Image",
        },
        true
      )

      console.log("res")
      console.log(res)
      setContent(res)
    } catch (e) {
      console.error(e)
      setError(true)
    }
  }

  return (
    <div className="dagger-page">
      <HeaderComponent />
      {!content && (
        <div className="dagger-form">
          <h4>Please enter your password to access this page</h4>
          <input
            type="password"
            value={password}
            placeholder="Password..."
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            disabled={!password}
            onClick={handleFetchPage}
            className="dagger-outline-btn"
          >
            View
          </button>
          {error && (
            <div className="dagger-error">
              Uh oh. Looks like that password might be incorrect. Please try
              again
            </div>
          )}
        </div>
      )}
      {password && content && (
        <div className="dagger-form">
          <h3>{content.attributes.ClientName}</h3>
          <p>{content.attributes.WelcomeCopy}</p>
        </div>
      )}
      <FooterComponent />
    </div>
  )
}

export default ClientDemoPage
